import React from 'react';

import MessageTemplatePage from '../components/MessageTemplate';

const MessageGroupContainer = () => {
  return <MessageTemplatePage />;
};

export default MessageGroupContainer;
